import type { ReactNode } from 'react'

import Text from 'components/ui/text'
import { translate } from 'utils/translation'
import { cn } from 'utils/classMerge'

interface SubscribingPolicyProps {
  planText: string
  className?: string
}

export const SubscribingPolicy = ({
  planText,
  className,
}: SubscribingPolicyProps) => {
  const text = translate(
    'subscribe_agree',
    <Text
      as="a"
      href="https://neilpatel.com/terms/"
      target="_blank"
      className="tw-text-zinc-500 tw-underline tw-text-xs xs:tw-text-sm"
    >
      terms_of_service
    </Text>,
    planText,
    <Text
      as="a"
      href="https://neilpatel.com/privacy/"
      target="_blank"
      className="tw-text-zinc-500 tw-underline tw-text-xs xs:tw-text-sm"
    >
      privacy_policy
    </Text>,
  )

  return (
    <Text
      className={cn(
        'tw-text-xs xs:tw-text-sm tw-text-zinc-500 tw-mb-0 tw-text-left',
        className,
      )}
      renderChildren
    >
      {text?.map((item: string | ReactNode) => {
        if (typeof item === 'string') return item.replace(/<\/?a>/g, '')
        return item
      })}
    </Text>
  )
}
